import { render, staticRenderFns } from "./OrderExtra.vue?vue&type=template&id=fba6452e&"
import script from "./OrderExtra.vue?vue&type=script&lang=js&"
export * from "./OrderExtra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports